import OapImmersiveHotspots from './code/Scripts/components/OapImmersiveHotspots.vue';

export default {
  components: {
    OapImmersiveHotspots,
  },
};
